import React from 'react';
import {connect} from 'react-redux';
import {swapHttpToHttps} from '../utils/generalUtils';
import './userProfileLogo.css';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Avatar from 'material-ui/Avatar';
import ExitToApp from 'material-ui-icons/ExitToApp';
import {FormattedMessage} from 'react-intl';

const menuStyle = {
  maxWidth: 200
}
class UserProfileLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
    }
  }

  handleOnRequestChange = (value) => {
    this.setState({
      openMenu: value,
    });
  }

   render() {
      return (
        <div>
          <IconMenu
            anchorOrigin={{horizontal:'left', vertical:'bottom'}}
            iconButtonElement={
               <IconButton>
                 <Avatar
                   src = {swapHttpToHttps(this.props.userData.picUrl)}
                   size = {30}
                   backgroundColor = 'none'
                 />
               </IconButton>}
            open={this.state.openMenu}
            onRequestChange={this.handleOnRequestChange}
            menuStyle = {menuStyle}
          >
            <p className="userName"> {<FormattedMessage id="userProfileLogo.welcome"/>}{this.props.userData.fullName + "!" }</p>
            <MenuItem
               onClick = {this.props.logout}
               primaryText= {<FormattedMessage id="sidemenu.logoutText"/>}
               leftIcon={<ExitToApp/>}/>
          </IconMenu>
        </div>
      );
   }
}

const mapStateToProps = (state) => ({
   userData: state.user.data,
})

export default connect(
   mapStateToProps
)(UserProfileLogo);



// WEBPACK FOOTER //
// ./src/components/userProfileLogo.js